import React from 'react';

interface Props {
  color?: string;
  size?: number;
  otherProps?: React.SVGProps<SVGSVGElement>;
}

const ShopIcon: React.FC<Props> = ({size, color}) => {
  return (
    <svg viewBox="0 0 64 64" width={size ?? 64} height={size ?? 64}>
      <path
        fill={color ?? '#000'}
        d="M43.4 16.7c-.1-.1-.1-.2-.2-.3l-5.2-9c-.8-1.4-1.8-1.6-3.2-.8L23 13.3c-.8.4-1.2 1-1.3 1.7-.1.7.2 1.4.8 2 .1.1.2.2.4.2h2.4L24 15.3l12-6.8 1 1.7c1.3 2.2 2.5 4.3 3.8 6.5.1.1.3.5.6.5h2.2l-.2-.5zM26 10.1l.9-.5c.4-.2.8-.5 1.2-.7.2-.1.3-.4.3-.5 0-.6-.1-1.2-.5-1.6-.4-.4-1-.7-1.7-.7H15.7c-1.4 0-2.2.8-2.2 2.2v8.9h2.3V8.5H26v1.6zm22.7-8.6c1.1.2 3.1.7 3.1.8.1 1.3-.6 2.2-1.6 2.9-.5.4-1 .6-1.6 1-.3.2-.5.3-.8.5-.3.2-.4.3-.8.1.4-1.8.7-3.5 1.1-5.3 0-.1.2-.1.6 0zM50 12c.2 3.4-3.1 3.4-4.7 5.2.1-2.8 1.2-3.9 4.7-5.2zm-3.8-.2c.2-2.4.2-2.4 4.6-4.7.2 2-.2 2.4-4.6 4.7zm3.5 8.2c-.1 0 0 0 0 0z"
      />
      <g fill={color ?? '#000'}>
        <path d="M55.3 24.1c-.1-1-.2-2.4-1.5-3.3-1-.6-2.1-.7-3-.7h-40l-5 37.8c-.1.9.2 1.8.7 2.4.3.4 1.1 1.1 2.3 1.1L46 62.6h.3l9.2-2.7c1.7-.5 2.8-2 2.7-3.8l-2.9-32zM8.4 58.6c-.1-.1-.2-.3-.1-.5L13 22.5h31.4v37.7L9 58.9c-.3 0-.5-.1-.6-.3zm46.5-1L46.5 60V22.5H50.8c.7 0 1.3.1 1.6.3.3.2.4.7.4 1.5l2.9 32c.1.6-.3 1.1-.8 1.3z" />
        <path d="M33.4 30.2c-.6-.3-1.4 0-1.6.6-.7 1.6-.7 3.4-.6 5.3 0 1.8.1 3.6-.5 5.3-.3 1-1.3 1.7-2.6 1.8-1.5.2-3.1-.3-3.8-1.3-.9-1.3-1.4-3.4-1.2-5.6.1-.9.4-3.1 1.9-3.8.6-.3.8-1 .5-1.6-.3-.6-1.1-.8-1.7-.5-2.5 1.3-3.1 4.2-3.2 5.8-.1 1.3-.2 4.7 1.6 7.2 1.1 1.5 3 2.4 5.1 2.4.3 0 .7 0 1.1-.1 2.2-.3 4-1.6 4.6-3.4.8-2.2.7-4.3.7-6.2 0-1.7-.1-3.1.4-4.2.3-.8 0-1.5-.7-1.7z" />
      </g>
    </svg>
  );
};

export default ShopIcon;
